import { platformPath } from '../platform-module/contract';

const CENTRAL_PLATFORM = 'https://app.tuolen.com/platform/cartiq';

/** Only the old screen pathname is mapped; never copy search/hash or a return URL. */
export function platformAdminEntry(flag: unknown, path: string): string | null {
  if (flag !== 'true' || typeof path !== 'string') return null;
  try {
    const pathname = platformPath(path.split(/[?#]/, 1)[0]);
    return `${CENTRAL_PLATFORM}${pathname.slice('/superadmin'.length)}`;
  } catch {
    return null;
  }
}
